import { FC, MouseEvent } from 'react';

import { Grid, Notification } from '@purpur/library';

import { useInitializeTranslations } from '@telialt/common-cms/src/useTranslations';
import HtmlContent from '@telialt/common-html-content/src';

import { ErrorBlockWrapper } from './Error.styles';

export const ErrorBlock: FC = () => {
    const { t } = useInitializeTranslations();

    const handleOnClick = (event: MouseEvent<HTMLElement>) => {
        event.preventDefault();
        window.location.reload();
    };

    if (!t) {
        return null;
    }

    return (
        <ErrorBlockWrapper>
            <Grid>
                <Notification
                    status="error"
                    headingTag="h5"
                    heading={t['common.nextjs.error_block.title']}
                    role="alert"
                >
                    <HtmlContent content={t['common.nextjs.error_block.description']} />
                    <br />
                    <a href="#refresh" onClick={handleOnClick}>
                        {t['common.nextjs.error_block.action']}
                    </a>
                </Notification>
            </Grid>
        </ErrorBlockWrapper>
    );
};
